import React from 'react';
import { Immutable } from 'nuclear-js';
import CreateReactClass from 'create-react-class';

import RuntimeActions from 'data/app-runtime/actions';
import CommonStrings from 'resources/common-strings';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import PropTypes from 'prop-types';

export default CreateReactClass({
    displayName: 'create-pdf-success',

    PropTypes: {
        reportQueueLink: PropTypes.string.isRequired,
    },

    closeAlert() {
        RuntimeActions.setPageAlert(
            Immutable.Map({
                messageContent: null,
                isActive: false,
                actionStatus: '',
            })
        );
    },

    render() {
        return (
            <div className="success-state">
                <span className="icon icon-form-success" />
                <span>
                    <strong>We're working to create your PDF.</strong>
                    <br />
                    Once it's ready, it will be available in the &nbsp;
                    <a
                        key="reports-queue"
                        href={this.props.reportQueueLink}
                        onClick={() =>
                            Analytics.recordButtonClick(
                                CommonValues.SectionIDs.printAndShare,
                                'goto-reports-queue',
                                'success-banner'
                            )
                        }
                    >
                        Reports Queue
                    </a>
                </span>
                <span className="icon-close" onClick={this.closeAlert}>
                    {CommonStrings.collapse}
                </span>
            </div>
        );
    },
});
